import moment from 'moment';

export const getOrderItems = orderItems => {
  const filteredOrderItems = orderItems.filter(oi => oi.quantity > 0);
  const stallsOrder = filteredOrderItems.find(item => !!item.reservation && item.reservation.stallProduct) || null;
  const rvsOrder = filteredOrderItems.find(item => !!item.reservation && item.reservation.rvProduct) || null;
  const addOnOrderItems = filteredOrderItems.filter(item => item.addOnProduct);

  return {
    stallsOrder,
    rvsOrder,
    addOnOrderItems
  };
};

export const parseDateRange = (from, to) => `${moment(from).format('MM/DD/YY')} - ${moment(to).format('MM/DD/YY')}`;
